import type { OrganizationT } from '../../../types'
import { getCurrentOrgKey } from '../../callApi'

function getAvailableOrganization(
  organizations: OrganizationT[],
  preferredOrganizationKey = getCurrentOrgKey()
) {
  const enabledOrganizations = organizations.filter(({ disabled }) => !disabled)
  if (enabledOrganizations.length <= 1) {
    return enabledOrganizations[0]
  }

  return (
    enabledOrganizations.find(({ key }) => key === preferredOrganizationKey) ||
    enabledOrganizations[0]
  )
}

export default getAvailableOrganization
